var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Shape_5_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e21c21",
    id: "Shape_5"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e21c21"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M512,294c-0.1-51.5-41.7-93.2-93-93.2H53.2c22.3-27.2,63.6-77.8,63.6-77.8h-39 c0,0-77.5,93.6-77.5,94.1c0,0.1,77.5,92.5,77.5,92.5h39c0,0-43.7-51.9-65.5-77.8H419c34.2,0,62,27.9,62,62.2 c0,34.4-27.8,62.2-62,62.2H233v31.1h186c51.3,0,92.9-41.7,93-93.2V294z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.3c2cf4d07bdc6e49e9bb43193e51f471.svg";
export { ForwardRef as ReactComponent };